import { defineMessages } from 'react-intl';

export default defineMessages({
  footer_brand: {
    id: 'kustomer.chat.footer.brand',
    description: 'Label for KB article publish button',
    defaultMessage: 'by Kustomer',
  },
});
